module.exports = __webpack_public_path__ + "assets/2578072f42caeb73ad9ba20331cab14f.mp3";